export enum DueDateStatuses {
    InPlan = 'InPlan',
    Urgent = 'Urgent',
    OverDue = 'OverDue',
}
